'use strict';
// Filter that will pass input to 
angular.module('autoremind')
    .filter('FilterFilter', ['$filter', function ($filter) {
        return function (input, filterName) {
            if (input != '') {
                return $filter(filterName)(input);
            }
            return '';
        };
    }]);
angular.module('autoremind')
    .filter('BasicPhoneNumberFilter', function () {
    return function (input, countryPhonePrefix) {
        if (input != '') {
            if (countryPhonePrefix === undefined) {
                countryPhonePrefix = 1; // Default is US/CA
            }
            console.log('input', input);
            if (input.indexOf('@') == -1) {
                input = input.replace(/\s/g, ''); // remove spaces
                var inputPlain = input.replace(/[^0-9\+]+/g, ''); // remove non-digit chars
                if (inputPlain == "")
                    inputPlain = input;
                var inputPlainInt = inputPlain.replace(/^[\+|00]/, '');
                if ((inputPlainInt != "") && (inputPlain != inputPlainInt))
                    return inputPlainInt;
                if (inputPlainInt == "")
                    return inputPlainInt;
                return countryPhonePrefix + inputPlain;
            }
            else {
                return input;
            }
        }
        return '';
    };
});
// Look for first name after comma (e.g. 'Last, First' returns 'First'
angular.module('autoremind')
    .filter('BasicFirstNameFilter', function () {
    return function (input) {
        if (input != "") {
            var inputPlain = input.replace(/.*\,\s*/, '');
            if (inputPlain == "")
                inputPlain = input;
            var inputFirstName = inputPlain.replace(/\s+\S*$/, '');
            if (inputFirstName == "")
                inputFirstName = inputPlain;
            var noExtraSpaces = $.trim(inputFirstName);
            return noExtraSpaces;
        }
        return '';
    };
});
//Look for first name after comma (e.g. 'Last, First' returns 'First'
angular.module('autoremind')
    .filter('BasicFirstNameSpaceDelimitedFilter', function () {
    return function (input) {
        if (input != "") {
            input = input.trim();
            var parts = input.split(" ");
            var lastName = parts.shift();
            var inputFirstName = parts.join(" ");
            var noExtraSpaces = $.trim(inputFirstName);
            return noExtraSpaces;
        }
        return '';
    };
});
// Not used
angular.module('autoremind')
    .filter('PatientNameFilterUSPI', function () {
    return function (input) {
        if (input != "") {
            var inputPlain = input.replace(/.*\,\s*/, '');
            if (inputPlain == "")
                inputPlain = input;
            var inputFirstName = inputPlain.replace(/\s+\S*$/, '');
            if (inputFirstName == "")
                inputFirstName = inputPlain;
            //USPI - remove / in the end of name
            var inputFirstName2 = inputFirstName.replace(/\s+\S\x2f*$/, '');
            if (inputFirstName2 == "")
                inputFirstName2 = inputFirstName;
            //Trim leading and trailing spaces
            var noExtraSpaces = $.trim(inputFirstName2);
            return noExtraSpaces;
        }
        return '';
    };
});
angular.module('autoremind')
    .filter('AppointmentDateFilterUSPI', function () {
    return function (input) {
        if (input != "") {
            //var inputPlain = input.replace(/[^0-9\x2f\+]+/g, ''); // Remove anything not in date (format mm/dd/yy)
            //var inputPlain = input.replace(/([0-9])([AP])/g, '$1 $2'); // Add space between time and AM or PM
            //if (inputPlain == "") inputPlain = input;
            // NOTE: This is using datejs (datejs.com) because JavaScript's Date does not work with SQL dates on Safari and IE
            //return Date.parse(inputPlain, 'M/dd/yyyy hh:mmtt');
            return Date.parse(input, 'M/dd/yyyy hh:mmtt');
        }
        return '';
    };
});
// Not used
angular.module('autoremind')
    .filter('resourceFilter', function () {
    return function (input) {
        if (input != "") {
            var inputPlain = input.replace(/.*\,\s*/, '');
            if (inputPlain == "")
                inputPlain = input;
            var inputName = inputPlain.replace(/\s+\S*$/, '');
            if (inputName == "")
                inputName = inputPlain;
            //Trim leading and trailing spaces
            var noExtraSpaces = $.trim(inputName);
            return noExtraSpaces;
        }
        return '';
    };
});
// Directive to extend the <input type="file"> to watch the change event for when selecting a file
// TODO: Find a solution to reload when selecting the same file
angular.module('autoremind')
    .directive('importfile', ['$compile', 'dialogs',
    function ($compile, dialogs) {
        return {
            restrict: 'A',
            scope: {
                importfile: '='
            },
            link: function (scope, el, attrs, ctrl) {
                el.bind('change', function (event) {
                    console.log('importfile');
                    //logger.debug('change event.target: ' + event.target);
                    //logger.debug('change event.target.value: ' + event.target.value);
                    var files = event.target.files;
                    var file = null;
                    var filename = null;
                    if (files !== undefined) {
                        file = files[0];
                        filename = file.name;
                        //logger.debug('filename : ' + filename);
                    }
                    else {
                        /*filename = event.target.value;
                        var fake = filename.indexOf('fakepath');
                        if (fake >= 0) {
                            //logger.debug('fakepath found at index : ' + fake);
                        }*/
                        dialogs.error('Error', 'File API not supported by this browser.');
                        return;
                    }
                    scope.importfile = file ? file : undefined;
                    scope.$apply(function (scope) {
                        var fileVal = $('input[name=file]').val(file);
                        var filenameVal = $('input[name=filename]').val(file.name);
                        $compile(fileVal);
                        $compile(filenameVal);
                    });
                });
            }
        };
    }]);
/* Controllers for the autoremind.csv feature */
/**
 * Main screen controller for the csv screen
 */
angular.module('autoremind.csv', [])
    .controller('autoremind.csv.ScreenController', 
// Setup dependencies
['$scope', '$http', '$filter', '$sanitize', 'dialogs', 'logger', 'userProfile', 'csvImport', 'accountService',
    function ($scope, $http, $filter, $sanitize, dialogs, logger, userProfile, csvImport, accountService) {
        // Initialize
        $scope.viewModel = {}; // Needed for eg. allRows binding to correct scope
        $scope.notificationoffset = {};
        $scope.notificationoffsets = [];
        $scope.templates = [];
        $scope.message = {};
        $scope.message[1] = { mediatype: 'voice', template: null, destinatortype: 'home' }; // Preset UI for first message (if multiple messages the user must select type for other messages)
        $scope.csvImport = csvImport; // Making the service available from the view
        $scope.hasContent = false;
        $scope.inputfile = csvImport.inputFile;
        $scope.filename = csvImport.filename;
        $scope.rowSelected = null;
        $scope.sendUrlRoot = 'servlets/autoremind/send/?';
        $scope.statusUrlRoot = 'servlets/autoremind/status/?';
        $scope.type = 'choice'; // Default
        $scope.stopOnErrors = false;
        $scope.columnStatus = 0; // This will be set when parsing the file - to one column after the last column in the file
        //$scope.statusDate = $filter("date")( Date.now(), 'MM/dd/yyyy' );
        $scope.statusDate = new Date();
        $scope.importState = {
            "buttonLabel": "Reload",
            "busy": true //NOTE: Lock the button until first time a file is selected - TODO: Find better solution that checks if a file is selected?
        };
        csvImport.reset();
        $scope.countryPhonePrefix = 1;
        userProfile.getProfileIfNotLoaded(function () {
            logger.debug('SystemCheckController: got user profile');
            //$scope.systemcheckModel.timezone = userProfile.profileModel.timezone;
            //angularMomentConfig.timezone = userProfile.profileModel.tz;
        });
        // Listen to when a new file is selected
        /*$scope.$watch('inputfile.file', function(value) {
            //$scope.inputfile = value;
            var filename = value ? value.name : '';
            if (filename != '') {
                $scope.filename = value ? value.name : '';
                $scope.csvUpload(value);
            }
        });*/
        $scope.uploadFileSelected = function ($files) {
            var file = angular.isDefined($files[0]) ? $files[0] : $files;
            $scope.inputFile = file;
            $scope.csvUpload(file);
        };
        $scope.templatesFetchState = {
            "buttonLabel": "Reload template list",
            "busy": false
        };
        /*
        $scope.checkTemplate = function(template) {
    //    	$scope.template = template;
            logger.debug('template: ' + $scope.template.name + ' type=' + $scope.template.type + '  language=' + $scope.template.language);
        };
        */
        //$scope.action = "send";
        $scope.destinatorMax = 1; // The number of destinator types selected by user (e.g. home & cell => Max=2)
        /**
         * Starts sending appointments one by one.
         * Since the sending is async we'll iterate on the server response
         */
        $scope.sendAppointments = function (message, notificationoffset) {
            logger.debug('csv sendAppointment start (offset=' + notificationoffset + ')');
            if (!$scope.checkIfAnyCheckboxesSelected())
                return;
            if (!angular.isDefined(notificationoffset) || notificationoffset == 'undefined') {
                dialogs.notify('Note', 'No send time selected!');
                return;
            }
            if (!angular.isDefined(message[1].template) || message[1].template == 'undefined') {
                dialogs.notify('Note', 'No template selected!');
                return;
            }
            $scope.message[1].template = message[1].template;
            $scope.message[1].mediatype = message[1].mediatype;
            $scope.message[1].destinatortype = message[1].destinatortype;
            //logger.debug('csv sendAppointment count = ' + Object.keys(template).length + ')  vs ' + Object.keys($scope.template).length);
            //logger.debug('csv sendAppointment count = ' + Object.keys(message).length  + '  mediatype[1]=' + message[1].mediatype);
            $scope.notificationoffset.id = notificationoffset;
            $scope.destinatorMax = 1;
            if (message[2].mediatype != '' && message[2].template != '' && message[2].destinatortype != '') {
                $scope.destinatorMax = 2;
                $scope.message[2].template = message[2].template;
                $scope.message[2].mediatype = message[2].mediatype;
                $scope.message[2].destinatortype = message[2].destinatortype;
                if (message[1].template == message[2].template &&
                    message[1].mediatype == message[2].mediatype &&
                    message[1].destinatortype == message[2].destinatortype) {
                    dialogs.notify('Note', 'You can not send the same message twice to ' + (message[2].destinatortype == 'home' ? 'Home Phone' : 'Cell Phone'));
                    return;
                }
            }
            $scope.destinatorIndex = 1;
            $scope.countryPhonePrefix = 1;
            $scope.rowIndex = 0;
            if ($scope.rowIndex < csvImport.fileData.length) {
                var dialog = dialogs.confirm('Confirm', 'You are about to send to ' + $scope.getCountCheckedRows() + ' recipient(s). Are you sure?');
                dialog.result.then(function (button) {
                    // Yes 
                    $scope.sendNextRow();
                }, function (button) {
                    // Cancel
                });
                return;
            }
        };
        $scope.checkIfAnyCheckboxesSelected = function () {
            var foundChecked = false;
            for (var i = 0; i < csvImport.fileData.length; i++) {
                var checkbox = document.getElementById('rowSelected' + i);
                if (checkbox.checked) {
                    foundChecked = true;
                    break;
                }
            }
            if (!foundChecked) {
                dialogs.notify('Note', 'No rows selected!');
                return false;
            }
            return true;
        };
        $scope.getCountCheckedRows = function () {
            var rows = document.getElementsByName('rowSelected');
            var count = 0;
            for (var i = 0; i < csvImport.fileData.length; i++) {
                var checkbox = document.getElementById('rowSelected' + i);
                if (checkbox.checked) {
                    count++;
                }
            }
            return count;
        };
        $scope.destinatorTypeToIndex = function () {
            switch ($scope.message[$scope.destinatorIndex].destinatortype) {
                case "home":
                    return 1;
                case "cell":
                    return 2;
                case "email":
                    return 3;
            }
        };
        /**
         * Sending one row and on server response call itself to send next row until all rows are handled
         * It will only send rows with checkboxes checked.
         */
        $scope.sendNextRow = function () {
            var checkbox = document.getElementById('rowSelected' + $scope.rowIndex);
            $scope.rowSelected = checkbox;
            if (checkbox.checked) {
                var appointmentDateTimeDate;
                var appointmentDateTimeString;
                if ($scope.columnAppointmentDate === -1) { // If no date is given - schedule for today
                    appointmentDateTimeDate = Date.now();
                    if ($scope.destinatorIndex === 1) {
                        appointmentDateTimeString = $filter("date")(appointmentDateTimeDate, 'yyyy-MM-dd 23:59:00');
                    }
                    else {
                        appointmentDateTimeString = $filter("date")(appointmentDateTimeDate, 'yyyy-MM-dd 23:58:00');
                    }
                }
                else {
                    appointmentDateTimeDate = $filter($scope.dateFilter)(csvImport.fileData[$scope.rowIndex][$scope.columnAppointmentDate] + ' ' + csvImport.fileData[$scope.rowIndex][$scope.columnAppointmentTime]);
                    appointmentDateTimeString = $filter("date")(appointmentDateTimeDate, 'yyyy-MM-dd HH:mm');
                }
                var destinatorTypeIndex = $scope.destinatorTypeToIndex($scope.message[$scope.destinatorIndex].destinatortype);
                //var destinator = $filter($scope.phoneNumberFilter)( csvImport.fileData[ $scope.rowIndex ][ csvImport.columnDestinatorPhone[destinatorTypeIndex] ]);
                var destinator = csvImport.fileData[$scope.rowIndex][csvImport.columnDestinatorPhone[destinatorTypeIndex]];
                if (destinator === '' && $scope.dualDestinatorMode === 'OR') {
                    // If mode is OR then skip to next destinator if first is missing address
                    if ($scope.destinatorIndex === 1) {
                        //csvImport.fileData[ $scope.rowIndex ][ $scope.columnStatusDetail ] = ' / Destinator(s): ' + $scope.message[$scope.destinatorIndex].destinatortype + ' (missing)';
                        csvImport.fileData[$scope.rowIndex][$scope.columnStatusDetail] = ' / Destinator(s): ';
                        // Skip to next destinator without sending anything
                        $scope.destinatorIndex++;
                        if ($scope.destinatorIndex > $scope.destinatorMax) {
                            $scope.destinatorIndex = 1; // Reset for next row
                            $scope.rowSelected.checked = false;
                            //$scope.rowSelected.disabled = true;
                            $scope.rowIndex++;
                        }
                        if ($scope.rowIndex < csvImport.fileData.length) {
                            $scope.sendNextRow();
                        }
                        else {
                            $scope.viewModel.allRows = false;
                            //$scope.viewModel.allRows = {option : {}};
                            $scope.$apply();
                        }
                        return;
                    }
                }
                var profileName = $filter($scope.firstNameFilter)(csvImport.fileData[$scope.rowIndex][csvImport.columnPatientName]);
                $scope.url = $scope.sendUrlRoot +
                    "destinator=" + encodeURIComponent(destinator) +
                    "&profilename=" + encodeURIComponent(profileName) +
                    "&appointmentdatetime=" + encodeURIComponent(appointmentDateTimeString) +
                    "&template=" + encodeURIComponent($scope.message[$scope.destinatorIndex].template.name) +
                    "&type=" + encodeURIComponent($scope.message[$scope.destinatorIndex].template.type) +
                    "&language=" + encodeURIComponent($scope.message[$scope.destinatorIndex].template.language) +
                    "&notificationoffsetid=" + encodeURIComponent($scope.notificationoffset.id) +
                    "&userId=" + encodeURIComponent(accountService.currentUser.userId);
                if (csvImport.columnPatientLastName != -1) {
                    $scope.url += "&profilelastname=" + encodeURIComponent($filter($scope.firstNameFilter)(csvImport.fileData[$scope.rowIndex][csvImport.columnPatientLastName]));
                }
                // Not all csv types have provider, reason and location so check if defined first
                if (angular.isDefined(csvImport.columnProvider) && csvImport.columnProvider != -1) {
                    $scope.url += "&provider=" + encodeURIComponent(csvImport.fileData[$scope.rowIndex][csvImport.columnProvider]);
                }
                if (angular.isDefined(csvImport.columnReason) && csvImport.columnReason != -1) {
                    $scope.url += "&reason=" + encodeURIComponent(csvImport.fileData[$scope.rowIndex][csvImport.columnReason]);
                }
                if (angular.isDefined(csvImport.columnLocation) && csvImport.columnLocation != -1) {
                    $scope.url += "&location=" + encodeURIComponent(csvImport.fileData[$scope.rowIndex][csvImport.columnLocation]);
                }
                logger.debug('csv sendNotification url: ' + $scope.url);
                // Sending to AutoremindSend servlet
                $http({ method: 'GET', url: $scope.url }) // NOTE: Servlet for AR2 deleted!
                    .then(function (response) {
                    logger.debug('csv sendNotification() got data from server');
                    $scope.data = response.data;
                    $scope.status = response.data.status;
                    logger.debug(response.data);
                    //logger.error('error: ' + response.data.error);
                    logger.debug('Send result data: ' + response.data);
                    logger.debug('Send result: ' + response.data.status);
                    if ($scope.status === "ok") {
                        csvImport.fileData[$scope.rowIndex][$scope.columnStatus] = "Scheduled"; // Always show as "Scheduled" if at least one destinator type works
                        if ($scope.destinatorIndex === 1) {
                            csvImport.fileData[$scope.rowIndex][$scope.columnStatusDetail] = ' / Destinator(s): ' + destinator + ' (OK)';
                        }
                        else {
                            csvImport.fileData[$scope.rowIndex][$scope.columnStatusDetail] += ' + ' + destinator + ' (OK)';
                        }
                        // Move to next destinator - unless OR mode where we skip more destinators if the current send was successful
                        $scope.destinatorIndex++;
                        if ($scope.destinatorIndex > $scope.destinatorMax || $scope.dualDestinatorMode === 'OR') {
                            $scope.destinatorIndex = 1; // Reset for next row
                            $scope.rowSelected.checked = false;
                            //$scope.rowSelected.disabled = true;
                            $scope.rowIndex++;
                        }
                        if ($scope.rowIndex < csvImport.fileData.length) {
                            $scope.sendNextRow();
                            return;
                        }
                        else {
                            $scope.viewModel.allRows = false;
                            //$scope.viewModel.allRows = {option : {}};
                            $scope.$apply();
                        }
                    }
                    else {
                        logger.debug('status: ' + response.data.status + "   index" + $scope.rowIndex);
                        logger.error('error: ' + response.data.error);
                        if ($scope.destinatorIndex === 1) {
                            csvImport.fileData[$scope.rowIndex][$scope.columnStatus] = "Failed";
                            csvImport.fileData[$scope.rowIndex][$scope.columnStatusDetail] = ' / Destinator(s): ' + destinator + '(' + response.data.error + ')';
                        }
                        else {
                            csvImport.fileData[$scope.rowIndex][$scope.columnStatusDetail] += ' + ' + destinator + '(' + response.data.error + ')';
                        }
                        // Handle next row - or stop if user selected so
                        if ($scope.stopOnErrors === false) {
                            $scope.destinatorIndex++;
                            if ($scope.destinatorIndex > $scope.destinatorMax) {
                                $scope.destinatorIndex = 1; // Reset for next row
                                $scope.rowSelected.checked = false;
                                //$scope.rowSelected.disabled = false;
                                $scope.rowIndex++;
                            }
                            if ($scope.rowIndex < csvImport.fileData.length) {
                                $scope.sendNextRow();
                                return;
                            }
                            else {
                                $scope.viewModel.allRows = false;
                                //$scope.viewModel.allRows = {option : {}};
                                $scope.$apply();
                            }
                        }
                    }
                }, function (errorResponse) {
                    logger.error('ERROR: ' + errorResponse.data);
                    $scope.status = "error";
                    $scope.data = errorResponse.data;
                    // TODO: Display error to user
                    // Stop processing rows
                });
                if ($scope.destinatorIndex == 1)
                    csvImport.fileData[$scope.rowIndex][$scope.columnStatus] = "Sending";
                //$scope.rowSelected.checked = false;
                //$scope.rowSelected.disabled = true;
                logger.debug('sent index ' + $scope.rowIndex);
            }
            else { // If checkbox not checked
                // Handle next row
                $scope.rowIndex++;
                if ($scope.rowIndex < csvImport.fileData.length) {
                    $scope.sendNextRow();
                    return;
                }
                else {
                }
            }
        };
        /**
         * Starts getting status on appointments one by one.
         * Since the sending is async we'll iterate on the server response
         */
        $scope.checkStatus = function (message) {
            logger.debug('csv checkStatus start');
            if (!$scope.checkIfAnyCheckboxesSelected())
                return;
            //Disabled check to only get status for first type if no second type is given
            //$scope.destinatorMax = 1;
            //if (message[2].destinatortype != '') {
            $scope.destinatorMax = 2;
            //}
            $scope.destinatorIndex = 1;
            $scope.rowIndex = 0;
            if ($scope.rowIndex < csvImport.fileData.length) {
                $scope.getNextRowStatus();
                return;
            }
        };
        $scope.changeStatusDate = function (date) {
            $scope.statusDate = date;
        };
        /**
         * Get status for one and on server response call itself to get next row until all rows are handled
         * It will only get status for rows with checkboxes checked.
         */
        $scope.getNextRowStatus = function () {
            var checkbox = document.getElementById('rowSelected' + $scope.rowIndex);
            $scope.rowSelected = checkbox;
            if (checkbox.checked) {
                var appointmentDateTimeDate;
                var appointmentDateTimeString;
                if ($scope.columnAppointmentDate == -1) { // If no date is given - schedule for today
                    //appointmentDateTimeDate = Date.now();
                    //appointmentDateTimeDate = new Date($scope.statusDate);
                    appointmentDateTimeDate = new Date($scope.statusDate);
                    appointmentDateTimeString = $filter("date")(appointmentDateTimeDate, 'yyyy-MM-dd 23:59');
                }
                else {
                    appointmentDateTimeDate = $filter($scope.dateFilter)(csvImport.fileData[$scope.rowIndex][$scope.columnAppointmentDate] + ' ' + csvImport.fileData[$scope.rowIndex][$scope.columnAppointmentTime]);
                    appointmentDateTimeString = $filter("date")(appointmentDateTimeDate, 'yyyy-MM-dd HH:mm');
                }
                if ($scope.destinatorIndex == 1) {
                    csvImport.fileData[$scope.rowIndex][$scope.columnStatus] = '';
                }
                var destinatorTypeIndex = $scope.destinatorTypeToIndex($scope.message[$scope.destinatorIndex].destinatortype);
                //var destinator = $filter($scope.phoneNumberFilter)( csvImport.fileData[ $scope.rowIndex ][ csvImport.columnDestinatorPhone[destinatorTypeIndex] ]);
                var destinator = csvImport.fileData[$scope.rowIndex][csvImport.columnDestinatorPhone[destinatorTypeIndex]];
                if (destinator != '') {
                    // TODO: Send as JSON POST
                    $scope.url = $scope.statusUrlRoot +
                        "destinator=" + encodeURIComponent(destinator) +
                        "&appointmentdatetime=" + encodeURIComponent(appointmentDateTimeString);
                    logger.debug('csv status url: ' + $scope.url);
                    $http({ method: 'GET', url: $scope.url }) // NOTE: Servlet for AR2 deleted!
                        .then(function (response) {
                        logger.debug('csv getNextRowStatus() got data from server');
                        $scope.data = resonse.data;
                        $scope.status = response.data.status;
                        //logger.debug(data);
                        //logger.error('error: ' + response.data.error);
                        //logger.debug('Status result data: ' + response.data);
                        //logger.debug('Status result: ' + response.data.status);
                        if ($scope.data.messages.length > 0) {
                            //TODO: Traverse all notifications in reply, since there might in special cases be multiple
                            if ($scope.destinatorIndex === 1 || csvImport.fileData[$scope.rowIndex][$scope.columnStatus] == '' || csvImport.fileData[$scope.rowIndex][$scope.columnStatus] == 'Unscheduled') {
                                csvImport.fileData[$scope.rowIndex][$scope.columnStatus] = response.data.messages[0].messagestatustxt;
                                //csvImport.fileData[ $scope.rowIndex ][ $scope.columnStatusDetail ] = ' / Destinator(s): ' + destinator + '(' + response.data.messages[0].messagestatustxt + ':' + response.data.messages[0].notifications[0].status + ')';
                                csvImport.fileData[$scope.rowIndex][$scope.columnStatusDetail] = ' / Destinator(s): ' + destinator + '(' + response.data.messages[0].notifications[0].status + ')';
                            }
                            else {
                                if (csvImport.fileData[$scope.rowIndex][$scope.columnStatus] == 'Failed' || csvImport.fileData[$scope.rowIndex][$scope.columnStatus] == 'Unscheduled') {
                                    csvImport.fileData[$scope.rowIndex][$scope.columnStatus] = response.data.messages[0].messagestatustxt;
                                } /* else {
                          csvImport.fileData[ $scope.rowIndex ][ $scope.columnStatus ] = 'Failed';
                        }*/
                                //csvImport.fileData[ $scope.rowIndex ][ $scope.columnStatusDetail ] += ' + ' + destinator + '(' + response.data.messages[0].messagestatustxt +  ':' + response.data.messages[0].notifications[0].status + ')';
                                //if (csvImport.fileData[ $scope.rowIndex ][ $scope.columnStatusDetail ] == '') {
                                //	csvImport.fileData[ $scope.rowIndex ][ $scope.columnStatusDetail ] = ' / Destinator(s): ' + destinator + '(' + response.data.messages[0].notifications[0].status + ')';
                                //} else {
                                csvImport.fileData[$scope.rowIndex][$scope.columnStatusDetail] += ' + ' + destinator + '(' + response.data.messages[0].notifications[0].status + ')';
                                //}
                            }
                            $scope.destinatorIndex++;
                            if ($scope.destinatorIndex > $scope.destinatorMax) {
                                $scope.destinatorIndex = 1; // Reset for next row
                                $scope.rowSelected.checked = false;
                                //$scope.rowSelected.disabled = false;
                                $scope.rowIndex++;
                            }
                            if ($scope.rowIndex < csvImport.fileData.length) {
                                $scope.getNextRowStatus();
                                return;
                            }
                            else {
                                $scope.viewModel.allRows = false;
                                //$scope.viewModel.allRows = {option : {}};
                                $scope.$apply();
                            }
                        }
                        else {
                            logger.debug('Error result: ' + response.data.status + "   index" + $scope.rowIndex);
                            if ($scope.destinatorIndex == 1 || csvImport.fileData[$scope.rowIndex][$scope.columnStatus] == '' || csvImport.fileData[$scope.rowIndex][$scope.columnStatus] == 'Unscheduled') {
                                csvImport.fileData[$scope.rowIndex][$scope.columnStatus] = 'Failed';
                                csvImport.fileData[$scope.rowIndex][$scope.columnStatusDetail] = ' / Destinator(s): ' + destinator + '(' + response.data.error + ')';
                            }
                            else {
                                //if (csvImport.fileData[ $scope.rowIndex ][ $scope.columnStatusDetail ] == '') {
                                //	csvImport.fileData[ $scope.rowIndex ][ $scope.columnStatusDetail ] = ' / Destinator(s): ' + destinator + '(' + response.data.error + ')';
                                //} else {
                                csvImport.fileData[$scope.rowIndex][$scope.columnStatusDetail] += ' + ' + destinator + '(' + response.data.error + ')';
                                //}
                            }
                            // Handle next row - or stop if user selected so
                            if ($scope.stopOnErrors == false) {
                                $scope.destinatorIndex++;
                                if ($scope.destinatorIndex > $scope.destinatorMax) {
                                    $scope.destinatorIndex = 1; // Reset for next row
                                    $scope.rowSelected.checked = false;
                                    //$scope.rowSelected.disabled = false;
                                    $scope.rowIndex++;
                                }
                                if ($scope.rowIndex < csvImport.fileData.length) {
                                    $scope.getNextRowStatus();
                                    return;
                                }
                                else {
                                    $scope.viewModel.allRows = false;
                                    //$scope.viewModel.allRows = {option : {}};
                                    $scope.$apply();
                                }
                            }
                        }
                    }, function (errorResponse) {
                        //logger.error('ERROR: ' + errorResponse.data);
                        $scope.status = "error";
                        $scope.data = errorResponse.data;
                        // TODO: Display error to user
                        // Stop processing rows
                    });
                    if ($scope.destinatorIndex == 1)
                        csvImport.fileData[$scope.rowIndex][$scope.columnStatus] = "Checking";
                    logger.debug('sent index ' + $scope.rowIndex);
                }
                else { // No destinator
                    // Handle next row - or stop if user selected so
                    if ($scope.stopOnErrors == false) {
                        $scope.destinatorIndex++;
                        if ($scope.destinatorIndex > $scope.destinatorMax) {
                            $scope.destinatorIndex = 1; // Reset for next row
                            $scope.rowSelected.checked = false;
                            //$scope.rowSelected.disabled = false;
                            $scope.rowIndex++;
                        }
                        if ($scope.rowIndex < csvImport.fileData.length) {
                            $scope.getNextRowStatus();
                            return;
                        }
                        else {
                            $scope.viewModel.allRows = false;
                            //$scope.viewModel.allRows = {option : {}};
                            $scope.$apply();
                        }
                    }
                    ;
                }
                ;
            }
            else { // If checkbox not checked
                // Handle next row
                $scope.rowIndex++;
                if ($scope.rowIndex < csvImport.fileData.length) {
                    $scope.getNextRowStatus();
                    return;
                }
                else {
                    $scope.viewModel.allRows = false;
                    //$scope.viewModel.allRows = {option : {}};
                    $scope.$apply();
                }
            }
            ;
        };
        $scope.toggleStopOnErrors = function () {
            $scope.stopOnErrors = !$scope.stopOnErrors;
        };
        $scope.toggleAllRows = function (toggle) {
            /*
            var t = false;
            if (toggle === undefined) t = true; // on first click toggle is not defined
            else t = !toggle;
            */
            var t = toggle;
            for (var i = 0; i < csvImport.fileData.length; i++) {
                var checkbox = document.getElementById('rowSelected' + i);
                checkbox.checked = t;
            }
        };
        $scope.setType = function (type) {
            $scope.type = type;
            if ($scope.type == 'webselfstorage') {
                csvImport.fieldSeparator = ',';
            }
            else if ($scope.type == 'latepayment') {
                csvImport.fieldSeparator = ',';
            }
            else if ($scope.type == 'ederm') {
                // eDerm
                csvImport.fieldSeparator = ',';
            }
            else {
                // use default
            }
            $scope.fieldSeparator = csvImport.fieldSeparator;
        };
        $scope.csvUpload = function (file) {
            csvImport.type = $scope.type;
            csvImport.columnDestinatorPhone = {};
            csvImport.countryPhonePrefix = $scope.countryPhonePrefix;
            // Default mode (if multiple destinators are selected then send to both)
            $scope.dualDestinatorMode = 'AND';
            if ($scope.type == 'uspi') {
                // USPI
                $scope.columnAppointmentDate = 57;
                $scope.columnAppointmentTime = 58;
                $scope.columnPatientName = 35;
                csvImport.columnPatientName = 35;
                $scope.columnAccount = 36; // Only used in the view to help find accounts
                $scope.columnDestinatorPhone = 39;
                csvImport.columnDestinatorPhone[1] = 39;
                $scope.columnResourceFirstname = 48;
                csvImport.columnPatientLastName = -1;
                $scope.dateFilter = "AppointmentDateFilterUSPI";
                $scope.firstNameFilter = "BasicFirstNameFilter";
                $scope.phoneNumberFilter = "BasicPhoneNumberFilter";
                csvImport.phoneNumberFilter = "BasicPhoneNumberFilter";
                $scope.message[1] = { mediatype: 'voice', template: null, destinatortype: 'home' }; // Preset UI for first message (if multiple messages the user must select type for other messages)
                $scope.message[2] = { mediatype: '', destinatortype: '' };
            }
            else if ($scope.type == 'webselfstorage') {
                // WebSelfStorage
                csvImport.fieldSeparator = ',';
                $scope.columnAppointmentDate = -1; // Today
                $scope.columnAppointmentTime = -1; // 23:55
                $scope.columnPatientName = 20; //+20 lastname
                csvImport.columnPatientName = 20;
                csvImport.columnPatientLastName = 19;
                $scope.columnDestinatorPhone = 21; //+24 cellphone
                csvImport.columnDestinatorPhone[1] = 21; //Home
                csvImport.columnDestinatorPhone[2] = 24; //Cell
                $scope.message[1] = { mediatype: 'voice', template: null, destinatortype: 'home' }; // Preset UI for first message (if multiple messages the user must select type for other messages)
                $scope.message[2] = { mediatype: 'voice', destinatortype: 'home' };
                $scope.message[2] = { mediatype: '', destinatortype: 'cell' };
                //$scope.dateFilter = "AppointmentDateFilterUSPI";
                $scope.firstNameFilter = "BasicFirstNameFilter";
                $scope.phoneNumberFilter = "BasicPhoneNumberFilter";
                csvImport.phoneNumberFilter = "BasicPhoneNumberFilter";
            }
            else if ($scope.type == 'latepayment') {
                // Late Payment
                // Name;Email;Mobilephone;Homephone
                //csvImport.fieldSeparator = ';';
                csvImport.fieldSeparator = $scope.fieldSeparator;
                $scope.columnAppointmentDate = -1; // Today
                $scope.columnAppointmentTime = -1; // 23:55
                $scope.columnPatientName = 0; //+20 lastname
                csvImport.columnPatientName = 0;
                csvImport.columnPatientLastName = -1;
                $scope.columnDestinatorPhone = 2; //+24 cellphone
                csvImport.columnDestinatorPhone[1] = 3; //Home
                csvImport.columnDestinatorPhone[2] = 2; //Cell
                csvImport.columnDestinatorPhone[3] = 1; //Email
                $scope.message[1] = { mediatype: 'voice', template: null, destinatortype: 'home' }; // Preset UI for first message (if multiple messages the user must select type for other messages)
                $scope.message[2] = { mediatype: 'voice', destinatortype: 'home' };
                $scope.message[2] = { mediatype: '', destinatortype: 'cell' };
                //$scope.dateFilter = "AppointmentDateFilterUSPI";
                $scope.firstNameFilter = "BasicFirstNameFilter";
                $scope.phoneNumberFilter = "BasicPhoneNumberFilter";
                csvImport.phoneNumberFilter = "BasicPhoneNumberFilter";
            }
            else if ($scope.type == 'ederm') {
                // eDerm
                csvImport.fieldSeparator = ',';
                $scope.columnAppointmentDate = 5;
                $scope.columnAppointmentTime = 6;
                $scope.columnPatientName = 1;
                csvImport.columnPatientName = 0;
                csvImport.columnPatientLastName = -1;
                $scope.columnDestinatorPhone = 1;
                csvImport.columnDestinatorPhone[1] = 1; //Home
                csvImport.columnDestinatorPhone[2] = 3; //Cell
                // If multiple destinators are selected then send to first if address available otherwise send to second destinator
                $scope.dualDestinatorMode = 'OR';
                csvImport.columnProvider = 8;
                csvImport.columnReason = 7;
                csvImport.columnLocation = 9;
                $scope.dateFilter = "stringToDate";
                $scope.firstNameFilter = "BasicFirstNameFilter";
                $scope.phoneNumberFilter = "BasicPhoneNumberFilter";
                csvImport.phoneNumberFilter = "BasicPhoneNumberFilter";
                $scope.message[1] = { mediatype: 'voice', template: null, destinatortype: 'home' }; // Preset UI for first message (if multiple messages the user must select type for other messages)
                $scope.message[2] = { mediatype: '', destinatortype: '' };
            }
            else if ($scope.type == 'edermold') {
                // eDerm old format
                $scope.columnAppointmentDate = 10;
                $scope.columnAppointmentTime = 7;
                $scope.columnPatientName = 2;
                csvImport.columnPatientName = 2;
                csvImport.columnPatientLastName = -1;
                $scope.columnDestinatorPhone = 12;
                csvImport.columnDestinatorPhone[1] = 12;
                csvImport.columnProvider = 1;
                csvImport.columnReason = 4;
                csvImport.columnLocation = 6;
                $scope.dateFilter = "stringToDate";
                $scope.firstNameFilter = "BasicFirstNameSpaceDelimitedFilter";
                $scope.phoneNumberFilter = "BasicPhoneNumberFilter";
                csvImport.phoneNumberFilter = "BasicPhoneNumberFilter";
                $scope.message[1] = { mediatype: 'voice', template: null, destinatortype: 'home' }; // Preset UI for first message (if multiple messages the user must select type for other messages)
                $scope.message[2] = { mediatype: '', destinatortype: '' };
            }
            else {
                // Practice Choice
                $scope.columnAppointmentDate = 2;
                $scope.columnAppointmentTime = 3;
                $scope.columnPatientName = 5;
                csvImport.columnPatientName = 5;
                csvImport.columnPatientLastName = -1;
                $scope.columnDestinatorPhone = 9;
                csvImport.columnDestinatorPhone[1] = 9;
                $scope.dateFilter = "stringToDate";
                $scope.firstNameFilter = "BasicFirstNameFilter";
                $scope.phoneNumberFilter = "BasicPhoneNumberFilter";
                csvImport.phoneNumberFilter = "BasicPhoneNumberFilter";
                $scope.message[1] = { mediatype: 'voice', template: null, destinatortype: 'home' }; // Preset UI for first message (if multiple messages the user must select type for other messages)
                $scope.message[2] = { mediatype: '', destinatortype: '' };
            }
            csvImport.reset();
            $scope.importState.buttonLabel = 'Loading & parsing...';
            $scope.importState.busy = true;
            csvImport.importAndParseFile($scope.inputFile, function () {
                // Success
                logger.debug('Imported file');
                $scope.columnStatus = csvImport.columnStatus;
                $scope.columnStatusDetail = csvImport.columnStatusDetail;
                //$scope.columnDuplicateState = csvImport.columnDuplicateState; //Obsolete
                $scope.importState.buttonLabel = 'Reload...';
                $scope.importState.busy = false;
                $scope.hasContent = true;
                //$scope.viewModel.allRows.checked = false;
                //            $scope.viewModel.allRows = {option : {}};
                $scope.viewModel.allRows = false;
                //logger.debug('$scope.viewModel.allRows.checked=' + $scope.viewModel.allRows);
                $scope.$apply();
            }, function () {
                // Error
                logger.debug('Error loading file ');
                $scope.importState.buttonLabel = 'Reload...';
                $scope.importState.busy = false;
                // TODO: Display error to user
                $scope.hasContent = false;
            });
            var issuedReload = false;
            // Make sure the template list is loaded at least the first time opening the view
            if ($scope.templates.length === 0) {
                // Only load templates if not loaded yet
                // And only reload profile if no templates loaded so far
                if (userProfile.profileModel.templates.length === 0) {
                    // Get templates list on init
                    $scope.reloadTemplates();
                    issuedReload = true;
                }
                else {
                    // If the user profile already has templates loaded then just use them
                    $scope.templates = userProfile.profileModel.templates;
                    $scope.selectFirstTemplate($scope.message[1].mediatype); // Only initialise for the first message
                    $scope.templatesFetchState.busy = false;
                    $scope.notificationoffsets = userProfile.profileModel.notificationoffsets;
                    $scope.selectOffsetById(1);
                }
            }
        };
        /*
         * Reloads the template list
         */
        $scope.reloadTemplates = function () {
            logger.debug('ScreenController: reloading templates');
            $scope.templatesFetchState.buttonLabel = 'Loading...';
            $scope.templatesFetchState.busy = true;
            userProfile.getProfile(function () {
                logger.debug('ScreenController.reloadTemplates(): got user profile with templates');
                $scope.templates = userProfile.profileModel.templates;
                $scope.selectFirstTemplate($scope.message[1].mediatype); // Only initialise for the first message
                $scope.templatesFetchState.busy = false;
                $scope.templatesFetchState.buttonLabel = 'Reload template list';
                $scope.notificationoffsets = userProfile.profileModel.notificationoffsets;
                var offset = 1;
                if (angular.isDefined($scope.notificationoffset.id)) {
                    offset = $scope.notificationoffset.id;
                }
                $scope.selectOffsetById(offset);
            });
        };
        /*
         * Selects (in the UI) the first template of the given type
         */
        $scope.selectFirstTemplate = function (type) {
            for (var i = 0; i < $scope.templates.length; i++) {
                if ($scope.templates[i].type == type) {
                    $scope.message[1].template = $scope.templates[i];
                    return;
                }
            }
        };
        /*
         * Selects (in the UI) the first template of the given type
         */
        $scope.selectOffsetById = function (id) {
            for (var i = 0; i < $scope.notificationoffsets.length; i++) {
                if ($scope.notificationoffsets[i].id == id) {
                    $scope.notificationoffset = $scope.notificationoffsets[i];
                    return;
                }
            }
        };
        /*
         * Used by UI as label for a template
         */
        $scope.templateLabel = function (template) {
            //return '' + template.displayname + ' [' + template.type + ' (' + template.language + '): ' + template.name + ']';
            return '' + template.displayname + ' (' + template.language.toUpperCase() + ')';
        };
        $scope.offsetLabel = function (offset) {
            return '' + offset.id + ':' + offset.displayname;
        };
        $scope.openDialog = function (videoidd) {
            logger.debug('videoidd=' + videoidd);
            dialogs.create('/dialogs/videodialog.html', 'videoDialogController', { videoId: videoidd }, { key: false, back: 'static' });
        };
        $scope.selectMediaType = function (message) {
            //alert('T:' + $scope.message[1].mediatype );
            if ($scope.message[message].mediatype === 'email') {
                $scope.message[message].destinatortype = 'email';
            }
            if ($scope.message[message].mediatype === 'sms') {
                $scope.message[message].destinatortype = 'cell';
            }
            if ($scope.message[message].mediatype === 'voice') {
                $scope.message[message].destinatortype = 'home';
            }
        };
    }])
    .run(['$templateCache', function ($templateCache) {
        $templateCache.put('/dialogs/videodialog.html', '<div class="modal-header"><button style="margin-top: 0px" type="button" class="close" ng-click="close()">&times;</button><h4 class="modal-title"><span class="glyphicon glyphicon-film"></span></span> Instructions video</h4></div><div class="modal-body" style="text-align: center;"><iframe class="youtube-player" type="text/html" ng-src="{{videoUrl}}" allowfullscreen frameborder="0"></div><div class="modal-footer"><button type="button" class="btn btn-default" ng-click="cancel()">Close</button></div>');
    }]);
angular.module('autoremind.csv')
    .controller('videoDialogController', 
// Setup dependencies
['$scope', '$uibModalInstance', 'data',
    function ($scope, $uibModalInstance, data) {
        $scope.data = (angular.isDefined(data)) ? data : '';
        $scope.videoUrl = 'https://www.youtube.com/embed/' + $scope.data.videoId;
        $scope.close = function () {
            $uibModalInstance.dismiss('Canceled');
        }; // end cancel
        $scope.hitEnter = function (evt) {
            if (angular.equals(evt.keyCode, 13))
                $scope.close();
        };
    }]);
// Controller to use to avoid errors on tabs missing controller on IE8 and IE9
angular.module('autoremind.csv')
    .controller('autoremind.csv.PaneDummyController', 
// Setup dependencies
['$scope', '$http', 'logger', 'csvImport',
    function ($scope, $http, logger, csvImport) {
        // Inizialize
        $scope.csvImport = csvImport; // Making the service available from the view
        //logger.info('In autoremind.csv.PaneDummyController');
    }]);
//# sourceMappingURL=csv.controllers.js.map